import React from "react";
import { Image, View, TouchableWithoutFeedback } from "react-native";
import giveRating from "../utils/giveRating";

const BAD_RATING_IF_LESS_THAN = 4;

const EmojiView = React.memo(
  ({
    showReopenModalHandler,
    handleReload,
    ticket_id,
    issueLevel1,
    type,
    onEmojiClick,
  }) => {
    const [touched, setTouched] = React.useState(false);

    const renderGifImage = (type) => {
      switch (type) {
        case "terrible":
          return (
            <View style={{}}>
              <Image
                // source={require("@assets/images/gifEmojis/terrible.gif")}
                source={{
                  uri: "https://pub-storage-svc.citymall.live/1628741900376Terrible@3x.gif",
                }}
                style={{ width: 48, height: 48, margin: 0 }}
              />
            </View>
          );
        case "bad":
          return (
            <View style={{}}>
              <Image
                // source={require("@assets/images/gifEmojis/bad.gif")}
                source={{
                  uri: "https://pub-storage-svc.citymall.live/1628741865199Bad@3x.gif",
                }}
                style={{ width: 48, height: 48, margin: 0 }}
              />
            </View>
          );

        case "okay":
          return (
            <View style={{}}>
              <Image
                // source={require("@assets/images/gifEmojis/okay.gif")}
                source={{
                  uri: "https://pub-storage-svc.citymall.live/1628741823647Okay@3x.gif",
                }}
                style={{ width: 48, height: 48, margin: 0 }}
              />
            </View>
          );

        case "good":
          return (
            <View>
              <Image
                // source={require("@assets/images/gifEmojis/good.gif")}
                source={{
                  uri: "https://pub-storage-svc.citymall.live/1628741764772Good@3x.gif",
                }}
                style={{ width: 48, height: 48, margin: 0 }}
              />
            </View>
          );
        case "great":
          return (
            <View>
              <Image
                // source={require("@assets/images/gifEmojis/great.gif")}
                source={{
                  uri: "https://pub-storage-svc.citymall.live/1628741797548Great@3x.gif",
                }}
                style={{ width: 48, height: 48, margin: 0 }}
              />
            </View>
          );
      }
    };
    const renderDeselectImage = (type) => {
      switch (type) {
        case "terrible":
          return (
            <TouchableWithoutFeedback onPress={() => onEmojiClick(1)}>
              <View
                style={{
                  width: 48,
                  height: 48,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  source={{
                    uri: "https://pub-storage-svc.citymall.live/1628741456867Terrible_deselect.png",
                  }}
                  style={{ width: 32, height: 32 }}
                />
              </View>
            </TouchableWithoutFeedback>
          );

        case "bad":
          return (
            <TouchableWithoutFeedback onPress={() => onEmojiClick(2)}>
              <View
                style={{
                  width: 48,
                  height: 48,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  source={{
                    uri: "https://pub-storage-svc.citymall.live/1628741186130Bad_deselect.png",
                  }}
                  style={{ width: 32, height: 32 }}
                />
              </View>
            </TouchableWithoutFeedback>
          );
        case "okay":
          return (
            <TouchableWithoutFeedback onPress={() => onEmojiClick(3)}>
              <View
                style={{
                  width: 48,
                  height: 48,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  source={{
                    uri: "https://pub-storage-svc.citymall.live/1628741533212Okay_deselect.png",
                  }}
                  style={{ width: 32, height: 32 }}
                />
              </View>
            </TouchableWithoutFeedback>
          );

        case "good":
          return (
            <TouchableWithoutFeedback
              onPress={() => onEmojiClick(4, setTouched)}
            >
              <View
                style={{
                  width: 48,
                  height: 48,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  source={{
                    uri: "https://pub-storage-svc.citymall.live/1628741580231Good_deselect.png",
                  }}
                  style={{ width: 32, height: 32 }}
                />
              </View>
            </TouchableWithoutFeedback>
          );
        case "great":
          return (
            <TouchableWithoutFeedback
              onPress={() => onEmojiClick(5, setTouched)}
            >
              <View
                style={{
                  width: 48,
                  height: 48,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  source={{
                    uri: "https://pub-storage-svc.citymall.live/1628741654233Great_deselect.png",
                  }}
                  style={{ width: 32, height: 32 }}
                />
              </View>
            </TouchableWithoutFeedback>
          );
      }
    };

    return touched ? renderGifImage(type) : renderDeselectImage(type);
  },
);

export default EmojiView;
